import { CompanySettings, CompanySettingsValues } from "../entities/CompanySettings";
import { SettingsRepository } from "../repositories/SettingsRepository";

/**
 * Saves changes to the GST panel.
 *
 * Sends only the fields that actually differ from what was loaded, same as
 * UpdateCompanySettingsUseCase. That diff is doing real work here rather than
 * just trimming the payload: the Cashfree secret is loaded as "" because the
 * server never sends it, so an untouched field compares equal and is left out
 * of the request entirely. Only a secret somebody typed is ever transmitted.
 */
export class UpdateGstSettingsUseCase {
  constructor(private readonly repository: SettingsRepository) {}

  execute(
    original: CompanySettingsValues,
    edited: CompanySettingsValues,
    signal?: AbortSignal
  ): Promise<CompanySettings> {
    return this.repository.updateGstSettings(this.changedFields(original, edited), signal);
  }

  /** The subset of `edited` whose values differ from `original`. */
  private changedFields(
    original: CompanySettingsValues,
    edited: CompanySettingsValues
  ): Partial<CompanySettingsValues> {
    const changes: Partial<CompanySettingsValues> = {};

    Object.keys(edited).forEach((field) => {
      if (edited[field] !== original[field]) {
        changes[field] = edited[field];
      }
    });

    return changes;
  }
}
